(function () {
  var STORAGE_KEY = 'sho_wheel_state_v2';
  var SHOW_AGAIN_AFTER_DISMISS_DAYS = 3;
  var SPIN_DURATION_MS = 5300;

  var I18N = {
    fr: {
      emailError: "Merci d'entrer une adresse email valide.",
      surpriseTitle: 'Ton cadeau surprise est arrivé !',
      pct10Title: 'Tu gagnes 10% de réduction !',
      pct15Title: 'Tu gagnes 15% de réduction !',
      shippingTitle: 'Livraison offerte débloquée !',
      useCode: 'Utiliser mon code',
      addToCart: 'Ajouter au panier',
      keepShopping: 'Continuer mes achats',
      genericError: 'Une erreur est survenue, réessaie dans un instant.'
    },
    en: {
      emailError: 'Please enter a valid email address.',
      surpriseTitle: 'Your surprise gift has arrived!',
      pct10Title: 'You win 10% off!',
      pct15Title: 'You win 15% off!',
      shippingTitle: 'Free shipping unlocked!',
      useCode: 'Use my code',
      addToCart: 'Add to cart',
      keepShopping: 'Keep shopping',
      genericError: 'Something went wrong, please try again in a moment.'
    }
  };

  function t() {
    var locale = (window.__SHO_WHEEL__ && window.__SHO_WHEEL__.locale) === 'fr' ? 'fr' : 'en';
    return I18N[locale];
  }

  // 4 prize types, equal odds (2 of 8 slices each = 25%).
  var prizes = [
    { id: 'surprise' },
    { id: 'pct10' },
    { id: 'shipping' },
    { id: 'pct15' },
    { id: 'surprise' },
    { id: 'pct10' },
    { id: 'shipping' },
    { id: 'pct15' }
  ];

  var overlay, spinBtn, wheelEl, introEl, resultEl, closeBtn, emailForm, emailInput, emailError;

  function getState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function setState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function shouldShow() {
    var s = getState();
    if (s.played) return false;
    if (s.dismissedAt && Date.now() - s.dismissedAt < SHOW_AGAIN_AFTER_DISMISS_DAYS * 24 * 60 * 60 * 1000) {
      return false;
    }
    return true;
  }

  function openWheel() {
    overlay.classList.add('is-open');
    document.body.classList.add('sho-wheel-lock');
  }

  function closeWheel(markDismissed) {
    overlay.classList.remove('is-open');
    document.body.classList.remove('sho-wheel-lock');
    if (markDismissed) {
      var s = getState();
      s.dismissedAt = Date.now();
      setState(s);
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function pickPrizeIndex() {
    return Math.floor(Math.random() * prizes.length);
  }

  function spin() {
    if (spinBtn.disabled) return;
    spinBtn.disabled = true;

    var idx = pickPrizeIndex();
    var segmentMid = idx * 45 + 22.5;
    var extraSpins = 6;
    var currentRotation = wheelEl.__rotation || 0;
    var baseTurns = Math.floor(currentRotation / 360) + extraSpins;
    var targetRotation = baseTurns * 360 + (360 - segmentMid);
    if (targetRotation <= currentRotation) targetRotation += 360;

    wheelEl.style.transition = 'transform 5.2s cubic-bezier(0.17, 0.67, 0.12, 0.99)';
    wheelEl.style.transform = 'rotate(' + targetRotation + 'deg)';
    wheelEl.__rotation = targetRotation;

    window.setTimeout(function () {
      onSpinEnd(idx);
    }, SPIN_DURATION_MS);
  }

  function onSpinEnd(idx) {
    var prize = prizes[idx];
    var resolvedId = prize.id;
    if (resolvedId === 'surprise') {
      resolvedId = Math.random() < 0.5 ? 'surprise-green' : 'surprise-bordeaux';
    }
    var s = getState();
    s.played = true;
    s.prize = resolvedId;
    s.wonAt = Date.now();
    setState(s);
    showResult(resolvedId);
    confettiBurst();
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderLoading() {
    resultEl.innerHTML = '<div class="sho-wheel-result-emoji">⏳</div>';
  }

  function renderError() {
    resultEl.innerHTML =
      '<div class="sho-wheel-result-emoji">😕</div>' +
      '<h3 class="sho-wheel-result-title">' + escapeHtml(t().genericError) + '</h3>' +
      '<button type="button" class="sho-wheel-later">' + escapeHtml(t().keepShopping) + '</button>';
  }

  function resultTemplate(o) {
    return (
      '<div class="sho-wheel-result-emoji">' + o.emoji + '</div>' +
      '<h3 class="sho-wheel-result-title">' + escapeHtml(o.title) + '</h3>' +
      '<div class="sho-wheel-code">' + escapeHtml(o.code) + '</div>' +
      '<a class="sho-wheel-cta" href="' + o.href + '">' + escapeHtml(o.cta) + '</a>' +
      '<button type="button" class="sho-wheel-later">' + escapeHtml(t().keepShopping) + '</button>'
    );
  }

  function keychainResultTemplate(kc, code) {
    kc = kc || {};
    return (
      '<div class="sho-wheel-result-emoji">🔑</div>' +
      '<h3 class="sho-wheel-result-title">' + escapeHtml(t().surpriseTitle) + '</h3>' +
      (kc.image ? '<img class="sho-wheel-kc-img" src="' + kc.image + '" alt="' + escapeHtml(kc.title) + '">' : '') +
      '<div class="sho-wheel-code">' + escapeHtml(code) + '</div>' +
      '<button type="button" class="sho-wheel-cta" data-sho-wheel-add data-variant="' + kc.variantId + '" data-code="' + escapeHtml(code) + '">' + escapeHtml(t().addToCart) + '</button>' +
      '<button type="button" class="sho-wheel-later">' + escapeHtml(t().keepShopping) + '</button>'
    );
  }

  function fetchRandomCode(url) {
    return fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.json();
      })
      .then(function (list) {
        if (!Array.isArray(list) || !list.length) throw new Error('empty pool');
        return list[Math.floor(Math.random() * list.length)];
      });
  }

  function showResult(resolvedId) {
    introEl.hidden = true;
    resultEl.hidden = false;
    renderLoading();

    var cfg = window.__SHO_WHEEL__ || {};
    var codes = cfg.codes || {};
    var strings = t();

    if (resolvedId === 'pct10') {
      fetchRandomCode(codes.pct10Pool)
        .then(function (code) {
          resultEl.innerHTML = resultTemplate({
            emoji: '🎉',
            title: strings.pct10Title,
            code: code,
            cta: strings.useCode,
            href: '/discount/' + code + '?redirect=/cart'
          });
        })
        .catch(renderError);
    } else if (resolvedId === 'shipping') {
      fetchRandomCode(codes.shippingPool)
        .then(function (code) {
          resultEl.innerHTML = resultTemplate({
            emoji: '🚚',
            title: strings.shippingTitle,
            code: code,
            cta: strings.useCode,
            href: '/discount/' + code + '?redirect=/cart'
          });
        })
        .catch(renderError);
    } else if (resolvedId === 'pct15') {
      resultEl.innerHTML = resultTemplate({
        emoji: '✨',
        title: strings.pct15Title,
        code: codes.pct15,
        cta: strings.useCode,
        href: '/discount/' + codes.pct15 + '?redirect=/cart'
      });
      bindAddButton();
    } else if (resolvedId === 'surprise-green') {
      resultEl.innerHTML = keychainResultTemplate(cfg.keychainGreen, codes.green);
      bindAddButton();
    } else if (resolvedId === 'surprise-bordeaux') {
      resultEl.innerHTML = keychainResultTemplate(cfg.keychainBordeaux, codes.bordeaux);
      bindAddButton();
    }
  }

  function bindAddButton() {
    var addBtn = resultEl.querySelector('[data-sho-wheel-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addBtn.disabled = true;
        addKeychainAndRedirect(addBtn.getAttribute('data-variant'), addBtn.getAttribute('data-code'));
      });
    }
  }

  function addKeychainAndRedirect(variantId, code) {
    var redirect = function () {
      window.location.href = '/discount/' + code + '?redirect=/cart';
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(redirect)
      .catch(redirect);
  }

  function confettiBurst() {
    var colors = ['#000000', '#ffffff', '#eef1ea', '#333333'];
    var container = document.createElement('div');
    container.className = 'sho-wheel-confetti';
    for (var i = 0; i < 60; i++) {
      var piece = document.createElement('span');
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[Math.floor(Math.random() * colors.length)];
      piece.style.animationDelay = Math.random() * 0.4 + 's';
      piece.style.animationDuration = 2.2 + Math.random() * 1.4 + 's';
      container.appendChild(piece);
    }
    document.body.appendChild(container);
    window.setTimeout(function () {
      container.remove();
    }, 4200);
  }

  function onEmailSubmit(e) {
    var email = emailInput.value.trim();
    if (!isValidEmail(email)) {
      e.preventDefault();
      emailError.hidden = false;
      emailInput.setAttribute('aria-invalid', 'true');
      return;
    }
    // Valid: let the real Shopify customer form submit natively to the
    // hidden iframe (subscribes the email + accepts_marketing, no reload).
    emailError.hidden = true;
    var s = getState();
    s.email = email;
    setState(s);
    emailForm.hidden = true;
    spin();
  }

  function init() {
    overlay = document.getElementById('sho-wheel-overlay');
    if (!overlay) return;

    spinBtn = document.getElementById('sho-wheel-spin-btn');
    wheelEl = document.getElementById('sho-wheel');
    introEl = document.getElementById('sho-wheel-intro');
    resultEl = document.getElementById('sho-wheel-result');
    closeBtn = overlay.querySelector('.sho-wheel-close');
    emailForm = document.getElementById('sho-wheel-email-form');
    emailInput = document.getElementById('sho-wheel-email');
    emailError = document.getElementById('sho-wheel-email-error');
    emailForm.target = 'sho-wheel-newsletter-frame';

    closeBtn.addEventListener('click', function () {
      closeWheel(true);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeWheel(true);
    });
    emailForm.addEventListener('submit', onEmailSubmit);
    emailInput.addEventListener('input', function () {
      emailError.hidden = true;
      emailInput.removeAttribute('aria-invalid');
    });
    resultEl.addEventListener('click', function (e) {
      if (e.target && e.target.classList.contains('sho-wheel-later')) closeWheel(false);
    });

    if (shouldShow()) {
      window.setTimeout(openWheel, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
